import { Box } from "@chakra-ui/react"
import { AUGMENTATION_PANEL_TYPOGRAPHY_CSS } from "@pathwright/ux/src/components/augmentation/augmentationPanelStyles"
import type { AugmentationComponent } from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import PasswordChangeViewContainer from "@pathwright/auth/src/views/auth/password/change/PasswordChangeViewContainer"
import PasswordCreateViewContainer from "@pathwright/auth/src/views/auth/password/create/PasswordCreateViewContainer"
import { ConnectedProvider as SpaceConnectedProvider } from "@pathwright/auth/src/views/space/api/context"
import { useRef } from "react"
import BGMode from "../../components/BGMode"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"

const UserAugmentationChangePassword: AugmentationComponent = ({ toolbar }) => {
  const { me } = usePathwrightContext()
  // Store the initial value of no_password_set to avoid re-rendering
  // when the password is changed, so as to let the LazyPasswordChangeContainer
  // handle success state.
  const initialHasPassword = useRef(!me.no_password_set).current
  const onContinue = () => toolbar.onSelect(null)

  return (
    <Box
      className="UserAugmentationChangePassword"
      css={AUGMENTATION_PANEL_TYPOGRAPHY_CSS}
      w="100%"
    >
      <BGMode mode="light" px="2" pt={0} w="100%">
        <SpaceConnectedProvider>
          {initialHasPassword ? (
            <PasswordChangeViewContainer
              onContinue={onContinue}
              onCancel={onContinue}
              showHeading={false}
            />
          ) : (
            <PasswordCreateViewContainer
              onContinue={onContinue}
              onCancel={onContinue}
              showHeading={false}
            />
          )}
        </SpaceConnectedProvider>
      </BGMode>
    </Box>
  )
}

export default UserAugmentationChangePassword
